import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faPhone } from "@fortawesome/free-solid-svg-icons";

export default function RecentCalls({
  items = [],
  isLoading = false,
  onSelectCall,
}) {
  const [expandedNoteId, setExpandedNoteId] = useState(null);

  const handleToggleNote = (itemId) => {
    setExpandedNoteId((currentId) => (currentId === itemId ? null : itemId));
  };

  return (
    <section className="dialer-recent-calls">
      <div className="dialer-sidebar-header">
        <h2 className="dialer-section-title">Recent Calls</h2>
      </div>

      <div className="dialer-recent-list">
        {isLoading ? (
          <div className="dialer-panel-copy">Loading recent calls...</div>
        ) : items.length > 0 ? (
          items.map((item) => (
            <article
              key={item.id}
              className={`dialer-recent-item${
                expandedNoteId === item.id ? " is-expanded" : ""
              }`}
            >
              <div className="dialer-recent-item-top">
                <div>
                  {item.savedName ? (
                    <h3 className="dialer-recent-name">{item.savedName}</h3>
                  ) : null}
                  <p className="dialer-recent-number">{item.number}</p>
                </div>
                <span className="dialer-recent-outcome">{item.outcome}</span>
              </div>

              <div className="dialer-recent-item-bottom">
                <p className="dialer-recent-time">{item.timeLabel}</p>
                <div className="dialer-recent-actions" aria-label="Recent call actions">
                  {item.note ? (
                    <button
                      type="button"
                      className="dialer-recent-icon-button"
                      aria-label={
                        expandedNoteId === item.id ? "Collapse note" : "Show note"
                      }
                      onClick={() => handleToggleNote(item.id)}
                    >
                      <FontAwesomeIcon icon={faFileLines} />
                    </button>
                  ) : null}
                  <button
                    type="button"
                    onClick={() => onSelectCall(item)}
                    className="dialer-recent-icon-button"
                    aria-label={`Redial ${item.number}`}
                  >
                    <FontAwesomeIcon icon={faPhone} />
                  </button>
                </div>
              </div>

              {item.note && expandedNoteId === item.id ? (
                <div className="dialer-recent-note">
                  <p className="dialer-recent-note-text">{item.note}</p>
                </div>
              ) : null}
            </article>
          ))
        ) : (
          <div className="dialer-panel-copy">
            No recent calls available.
          </div>
        )}
      </div>
    </section>
  );
}
